import { MLSListing } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn.js';
import MLSDataInfoSection from './MLSDataInfoSection.js';
import MlsDataValueWithLabel from './MLSDataValueWithLabel.js';

const MLSLocationInfo = ({ listingData }: { listingData: MLSListing }) => (
  <>
    <MLSDataInfoSection title="Location">
      <MLSDataColumn>
        <MlsDataValueWithLabel value={listingData.SubdivisionName} label="Subdivision" />
        <MlsDataValueWithLabel value={listingData.NeighborhoodName} label="Neighborhood" />
      </MLSDataColumn>
      <MLSDataColumn>
        <MlsDataValueWithLabel value={listingData.MLSAreaMajor} label="Area" />
        <MlsDataValueWithLabel value={listingData.CountyOrParish} label="County" />
      </MLSDataColumn>
    </MLSDataInfoSection>
    <MlsDataValueWithLabel leftAlign value={listingData.Directions} label="Directions" />
  </>
);

export default MLSLocationInfo;
